import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";

import { ArticleCardContext } from "..";
import { API_PATHS } from "../../../../API/api_paths";
import { Divider } from "../../../../commonStyles";
import { useAppSelector } from "../../../../redux";
import { ArticleProps } from "../../../../redux/slices/article/Article";
import { ROUTES } from "../../../../utills/routes";
import { calculateTimePassed } from "../../../../utils";
import {
  FlexRow,
  FlexRowCenter,
  FlexRowSpaced
} from "../../Styles";
import { UpvoteDownvote } from "../../UpvoteDownvote";
import {
  BackButtonContainer,
  CardFooter,
  Container,
  CoverImage,
  UserInfoContainer,
  Wrapper,
} from "./style";

const CoverImageCard = () => {
  const navigate = useNavigate();
  const { typography, Color } = useTheme();
  const { title_content, cover_image, post_id } =
    useContext(ArticleCardContext);
  const { id = "", updated_at = "" } = (
    cover_image as ArticleProps.WithImageContent
  ).content_data?.[0];
  const { first_name, last_name, headline, profile_picture } = useAppSelector(
    (state) => state.me
  );
  const { content_data, created_at } =
    title_content as ArticleProps.WithTextContent;
  return (
    <Container>
      <CoverImage src={API_PATHS.posts.getPostImage + id + `?${updated_at}`} />
      <BackButtonContainer>
        <Components.IconButton
          iconType="ArrowLeft"
          disabled={false}
          kind="Opacity"
          onClick={() => {
            navigate(ROUTES.article + `?article_id=${post_id}`);
          }}
          size="Small"
        />
      </BackButtonContainer>
      <Wrapper>
        <Components.Text
          style={{ tokenStyle: typography.Heading.L }}
          text={content_data.Blueprint}
          lineHeight="line-height-700"
          fontWeight="font-weight-semibold"
        />
        <FlexRowSpaced>
          <FlexRowCenter $gapInPx={10}>
            <Components.Avatar
              size="Medium-48"
              src={profile_picture}
              type="Circle"
            />
            <UserInfoContainer>
              <FlexRowSpaced>
                <Components.Text
                  text={first_name + " " + last_name}
                  style={{ tokenStyle: typography.Body.M }}
                  fontWeight="font-weight-bold"
                  maxLineLength={1}
                  renderInSingleLine
                />
                <FlexRowCenter $gapInPx={2}>
                  <Components.Text
                    text={calculateTimePassed(created_at)}
                    style={{ tokenStyle: typography.Body.S }}
                    renderInSingleLine
                  />
                  <Components.Text
                    text={"•"}
                    style={{ tokenStyle: typography.Body.S }}
                  />
                  <Components.Icon type="Globe" size="16px" />
                </FlexRowCenter>
              </FlexRowSpaced>
              <Components.Text
                text={headline}
                style={{ tokenStyle: typography.Body.S }}
                color={Color.text["text-tertiary"].value}
                maxLineLength={1}
              />
            </UserInfoContainer>
          </FlexRowCenter>
          <Components.Button
            size="Medium"
            color="Neutral"
            kind="Secondary"
            disabled={false}
            label="Follow"
            onClick={() => {}}
            iconType="Plus"
            iconPosition="right"
          />
        </FlexRowSpaced>
        <Divider />
        <CardFooter>
          <UpvoteDownvote
            downVoteHandler={() => {}}
            downvoteCount={1}
            upvoteCount={1}
            upVoteHandler={() => {}}
            userVoted
          />
          <Components.Button
            size="Small"
            color="Primary"
            kind="Tertiary"
            disabled={false}
            label="100"
            onClick={() => {}}
            iconType="MessageCircle"
            iconPosition="left"
          />
          <Components.Button
            size="Small"
            color="Primary"
            kind="Tertiary"
            disabled={false}
            label="100"
            onClick={() => {}}
            iconType="Smile"
            iconPosition="left"
          />
          <Components.Button
            size="Small"
            color="Primary"
            kind="Tertiary"
            disabled={false}
            label="20"
            onClick={() => {}}
            iconType="Repeat"
            iconPosition="left"
          />
          <FlexRow $gapInPx={0}>
            <Components.IconButton
              disabled={false}
              iconType="Bookmark"
              kind="Tertiary"
              onClick={() => {}}
              size="Small"
            />
            <Components.IconButton
              disabled={false}
              iconType="Share"
              kind="Tertiary"
              onClick={() => {}}
              size="Small"
            />
          </FlexRow>
        </CardFooter>
      </Wrapper>
    </Container>
  );
};

export default CoverImageCard;
